export default __webpack_public_path__ + "static/media/step-one.4f1db07e.png";